<template>
  <v-app>
    <sidebar
      v-if="authenticated"
      :drawer.sync="drawer"
    />

    <toolbar
      v-if="authenticated"
      @toggleSidebar="drawer = !drawer"
    />

    <v-main>
      <router-view />
    </v-main>

    <preview-image-modal />

    <v-snackbar
      v-model="snackbarActive"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      app
    >
      <span v-html="snackbar.text" />
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click.native.prevent="$store.dispatch('closeAlert')"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>  <!-- end snackbar -->
  </v-app>
</template>

<script>
  import Toolbar from './components/navigation/Toolbar'
  import Sidebar from './components/navigation/Sidebar'
  import PreviewImageModal from './components/helpers/PreviewImageModal'
  import { mapGetters } from 'vuex'

  export default {
  name: 'App',
  components: {
    Sidebar, Toolbar, PreviewImageModal
  },
  data() {
    return {
      drawer: false
    }
  },
  computed: {
    snackbarActive: {
      get() {
        return this.$store.state.ui.alert.active
      },
      set(value) {
        if (!value) this.$store.dispatch('closeAlert')
      }
    },
    ...mapGetters({
      snackbar: 'alert'
    }),
    authenticated() {
      return this.$store.state.auth.authenticated
    }
  }
}
</script>
